<template>
<v-container
    class="mb-4 pa-5"
    fluid
    v-if="mode == 'default'"
  >
    <v-card
      v-for="(newsitem, index) in news"
      :key="index"
      class="mb-3"
      elevation="4"
    >
      <v-card-title>
        {{ newsitem.title }}
        <v-spacer></v-spacer>
        {{ newsitem.date.toLocaleDateString() }}
      </v-card-title>
      <v-card-subtitle>{{ newsitem.subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-container class="d-flex align-start ma-0 pa-0">

          <v-icon
            x-large
            v-if="newsitem.icon"
            class="mr-3"
          >{{ newsitem.icon }}</v-icon>

          <span v-html="newsitem.content"></span>

        </v-container>

      </v-card-text>
      <v-card-actions v-if="newsitem.link">
        <v-spacer></v-spacer>
        <v-btn
          plain
          x-small
          :href="newsitem.link"
        >
          more
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>

  <v-container
    class="mb-4 pa-5"
    fluid
    v-else-if="mode == 'widget'"
  >

    <!-- <v-list three-line>
      <template v-for="(item, index) in news">
        <v-subheader
          v-if="item.header"
          :key="index"
          v-text="item.header"
        ></v-subheader>


        <v-divider
        v-if="index > 0"

        :key="index"
        :inset="true"
        ></v-divider>

        <v-list-item
          :key="item.title"
        >
          <v-list-item-avatar>
            <v-icon x-large>{{ item.icon }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-html="item.title"></v-list-item-title>
            <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>


      </template>
    </v-list> -->

    <v-list
      subheader
      three-line
    >
      <v-list-item
        v-for="(item, index) in three_newest_news"
        :key="index"
      >
        <v-list-item-avatar>
          <!-- <v-icon
            class="grey lighten-1"
            dark
          >
            {{ item.icon }}
          </v-icon> -->
          <v-icon x-large>{{ item.icon }}</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="item.title"></v-list-item-title>
          <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
          <v-spacer></v-spacer>
          <v-list-item-action-text v-text="item.date.toLocaleDateString()"></v-list-item-action-text>
        </v-list-item-content>

        <!-- <v-btn icon to="/news">
            <v-icon color="grey lighten-1">mdi-information</v-icon>

          </v-btn> -->
      </v-list-item>
    </v-list>



    <!-- <v-card
      v-for="(newsitem, index) in news"
      :key="index"
      class="mb-3"
      elevation="4"
    >
      <v-card-title>
        {{ newsitem.title }}
        <v-spacer></v-spacer>
        {{ newsitem.date.toLocaleDateString() }}
      </v-card-title>
      <v-card-subtitle>{{ newsitem.subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-icon
          x-large
          v-if="newsitem.icon"
          class="mr-3"
        >{{ newsitem.icon }}</v-icon>
        <span v-html="newsitem.content"></span>
      </v-card-text>
      <v-card-actions v-if="newsitem.link">
        <v-spacer></v-spacer>
        <v-btn
          plain
          x-small
          :href="newsitem.link"
        >
          more
        </v-btn>
      </v-card-actions>
    </v-card> -->
  </v-container>
</template>

<script>
import config from "@/utils/config.json";

  export default {
    name: "News",
    props: [
      'mode'
    ],
    computed: {
      three_newest_news() {
        return this.news.slice(0, 3);
      }
    },
    methods: {
      referralLinkStaking(link) {
        return "<a href='https://wisetoken.net/staking/?w=" + config.referralAccount + "'>" + link + "</a>";
      },

    },
    data() {
      return {
        news: [
          // {
          //   title: "\"WISE-Lending\" explained",
          //   subtitle: "Offer your wise stakes as collateral",
          //   date: new Date("2021-02-18"),
          //   content: "Peter released new info about \"Wise-Lending\" in his latest Stream on <a href=\"https://www.youtube.com/watch?v=fCg2ulCKROc\">Youtube</a>",
          //   icon: "mdi-handshake",
          // },
          {
            title: "New Layout on Wiseinfo.io!",
            subtitle: "Brand new Layout released. Same content, modern layout!",
            date: new Date("2021-02-22"),
            content: "Wiseinfo.io has been released with a complete new layout. Modern, Sleek, Pleasing, Informative. Look around! More will follow soon, stay tuned, check back regularly!",
            icon: "mdi-newspaper",
          },
          {
            title: "Insurance Staking is LIVE!",
            subtitle: "Get 90% of your principle back, even if you unstake early!",
            date: new Date("2021-01-13"),
            content: "Insurance Stakes are a second layer contract on top of the original contract of, created by the Wise Foundation.",
            link: "/insurancestaking",
            icon: "mdi-shield-lock",
          },
          {
            title: "WISE Staking Live",
            subtitle: "WISE are distributed, Staking starts",
            date: new Date("2020-12-31"),
            content: "All the WISE have been distributed, the Liquidity Pool on Uniswap has been created, the LP Tokens have been burned/destroyed, and Staking is Live! Head over to " + this.referralLinkStaking("Wisestaking.net") + " for staking!",
            link: "/staking",
            icon: "mdi-chart-timeline",
          },
        ],
      }
    },
    components: {},
  };
</script>

<style>
</style>
